import React, { useEffect } from "react";

export const YandexAd = ({ blockId, type }) => {
    if (!blockId) {
        return null;
    }

    useEffect(() => {
        if (window.yaContextCb) {
            window.yaContextCb.push(() => {
                Ya.Context.AdvManager.render({
                    blockId,
                    renderTo: `yandex_rtb_${blockId}`,
                    ...(type && { type }),
                });
            });
        }
    }, [blockId]);

    return <div id={`yandex_rtb_${blockId}`}></div>;
};
